import React from 'react';
import { CFBaseFieldUtils, } from '@connectrn/ds-ui-base';
import { CFButton, CFIcon } from '../../../components';
import { CFFieldElements } from '../Field.styles';
export const FieldDecorator = ({ disabled = false, fieldSize = 'md', icon, }) => {
    const { FieldDecorator } = CFFieldElements;
    if (!icon)
        return null;
    if (typeof icon === 'string') {
        return (React.createElement(FieldDecorator, { isButton: false },
            React.createElement(CFIcon, { color: CFBaseFieldUtils.getIconColor({ disabled }), icon: icon, size: CFBaseFieldUtils.getIconSize({ fieldSize }) })));
    }
    return (React.createElement(FieldDecorator, { isButton: true },
        React.createElement(CFButton, Object.assign({ disabled: disabled, size: CFBaseFieldUtils.getIconButtonSize({ fieldSize }), variant: 'standalone' }, icon))));
};
